(() => {
  const initShelf = (shelf) => {
    if (!shelf || shelf.dataset.shelfReady === "true") return;
    const track = shelf.querySelector("[data-shelf-track]");
    const prev = shelf.querySelector("[data-shelf-prev]");
    const next = shelf.querySelector("[data-shelf-next]");
    const progress = shelf.parentElement.querySelector("[data-shelf-progress]");
    const thumb = progress?.querySelector("span");
    if (!track) return;
    shelf.dataset.shelfReady = "true";
    const step = () => {
      const card = track.querySelector(".pdp-card");
      if (!card) return track.clientWidth;
      const style = getComputedStyle(track);
      const gap = Number.parseFloat(style.columnGap || style.gap) || 28;
      return card.getBoundingClientRect().width + gap;
    };
    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      const canScroll = max > 4;
      shelf.classList.toggle("is-scrollable", canScroll);
      if (prev) prev.disabled = !canScroll || track.scrollLeft <= 2;
      if (next) next.disabled = !canScroll || track.scrollLeft >= max - 2;
      if (progress && thumb) {
        progress.hidden = !canScroll;
        if (!canScroll) return;
        const ratio = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
        thumb.style.width = `${Math.min(1, ratio) * 100}%`;
        thumb.style.left = `${track.scrollWidth ? (track.scrollLeft / track.scrollWidth) * 100 : 0}%`;
      }
    };
    prev?.addEventListener("click", () => track.scrollBy({ left: -step(), behavior: "smooth" }));
    next?.addEventListener("click", () => track.scrollBy({ left: step(), behavior: "smooth" }));
    track.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    if (typeof ResizeObserver !== "undefined") new ResizeObserver(update).observe(track);
    track.scrollLeft = 0;
    update();
  };

  const initShelvesIn = (root = document) => {
    root.querySelectorAll("[data-shelf]").forEach((shelf) => {
      if (shelf.closest("[data-recent-shelf]")) return;
      initShelf(shelf);
    });
  };

  const initRecentShelves = () => {
    document.querySelectorAll("[data-recent-shelf] [data-shelf]").forEach(initShelf);
  };

  window.miipasInitShelf = initShelf;
  window.miipasInitShelves = initShelvesIn;

  document.addEventListener("miipas:recent-ready", initRecentShelves);
  if (window.miipasRecentReady) initRecentShelves();

  const boot = () => initShelvesIn(document);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
